export const digidCodes: { [code: string]: string } = {
  PIO: 'Pionira',
  UBI: 'Ubidata',
  DGF: 'DigiForm',
  OMS: 'OMS SOFTWARE',
  LZP: 'LZP',
  WDS: 'VESTA GROUP (systeem WasteDesk)',
  ZEN: 'Trustteam',
  DAS: 'Dashdoc',
  FLA: 'Flagstone',
  APL: 'Aplikas',
  SEO: 'QEOS',
  HEG: 'HEMMIS (voor bedrijf GRCT)',
  HEW: 'HEMMIS (voor bedrijf Geo-Group, afdeling WWT Geel)',
  FDS: 'VESTA GROUP (systeem FormDesk)',
  SEL: 'SELUX',
};

export const getDigidSysteemNaam = (code: string): string => digidCodes[code] || code;
